import type { ReactNode } from 'react';
import { Outlet } from 'react-router';
import { Logo } from '../components/Logo';
import { OfflineBanner } from '../components/OfflineBanner';
import { AuthHero } from './AuthHero';

export function AuthLayout({ children }: { children?: ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col">
      <OfflineBanner />
      <div className="grid flex-1 lg:grid-cols-2">
        <aside className="relative hidden flex-col overflow-hidden bg-linear-to-b from-brand via-brand to-brand-500 p-10 text-white lg:flex">
          <AuthHero />
          <div className="relative">
            <Logo variant="white" />
          </div>
          <div className="relative mt-[12vh] max-w-md animate-rise motion-reduce:animate-none">
            <p className="font-heading text-display font-bold">A calmer way to look after home.</p>
            <p className="mt-3 text-white/85">
              Raise maintenance requests, follow their progress and talk to management, all in one
              place.
            </p>
          </div>
        </aside>
        <main className="flex items-center justify-center px-4 py-10 sm:px-6">
          <div className="w-full max-w-md">
            <div className="mb-8 lg:hidden">
              <Logo />
            </div>
            {children ?? <Outlet />}
          </div>
        </main>
      </div>
    </div>
  );
}
